import React, { useContext } from 'react';

import { ButtonRound } from '@ontruck/orc';

import DriverForm from 'modules/my-fleet/driver-form';
import MyFleetContext from 'modules/my-fleet/context';
import MyFleetCard from 'modules/my-fleet/driver-card';

import { StyledWrapper } from 'modules/assignment-cards/styled';

import { StyledAdd } from './styled';

import ZeroResults from './ZeroResults';
import { Loading } from 'components/Loading';

const MyFleetSection = ({ vertical, assignActionComponent, showAddOption = false }) => {
  const { myFleet, isAddMode, onSubmit, onCancel, onZeroResultsAdd, isLoading } =
    useContext(MyFleetContext);

  const hasElements = myFleet?.length > 0;

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Loading />
      </div>
    );
  }

  return (
    <>
      {(hasElements || (!hasElements && isAddMode)) && (
        <StyledWrapper data-testid="my_fleet_container" vertical={vertical}>
          {showAddOption && (
            <>
              {isAddMode && <DriverForm onCancelClick={onCancel} onSubmitClick={onSubmit} />}
              {!isAddMode && (
                <StyledAdd mLeft="S" mRight="S" mBottom={vertical && 'S'}>
                  <ButtonRound skin="primary" size="S" onClick={onZeroResultsAdd} icon="plus" />
                </StyledAdd>
              )}
            </>
          )}
          {myFleet?.map(({ id }) => (
            <MyFleetCard
              key={id}
              id={id}
              vertical={vertical}
              assignActionComponent={assignActionComponent}
              allowRemove={showAddOption}
            />
          ))}
        </StyledWrapper>
      )}
      {!hasElements && <ZeroResults onAddClick={onZeroResultsAdd} showAddOption={showAddOption} />}
    </>
  );
};

export default MyFleetSection;
